var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsFLag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.435,
    height: 22.381,
    viewBox: "0 0 34.435 22.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "US-FLag",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11579",
    "data-name": "Path 11579",
    d: "M15.26,5.453H0V7.175H34.434V5.453Z",
    transform: "translate(0 6.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4081",
    "data-name": "Rectangle 4081",
    width: 34.434,
    height: 1.722,
    transform: "translate(0 13.773)",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4082",
    "data-name": "Rectangle 4082",
    width: 34.434,
    height: 1.722,
    transform: "translate(0 17.216)",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4083",
    "data-name": "Rectangle 4083",
    width: 19.174,
    height: 1.722,
    transform: "translate(15.26 10.33)",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4084",
    "data-name": "Rectangle 4084",
    width: 34.434,
    height: 1.722,
    transform: "translate(0 20.66)",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4085",
    "data-name": "Rectangle 4085",
    width: 34.434,
    height: 1.722,
    transform: "translate(0 18.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4086",
    "data-name": "Rectangle 4086",
    width: 34.434,
    height: 1.722,
    transform: "translate(0 15.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4087",
    "data-name": "Rectangle 4087",
    width: 19.174,
    height: 1.722,
    transform: "translate(15.26 3.444)",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4088",
    "data-name": "Rectangle 4088",
    width: 19.174,
    height: 1.722,
    transform: "translate(15.26 0)",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4089",
    "data-name": "Rectangle 4089",
    width: 19.174,
    height: 1.722,
    transform: "translate(15.26 8.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4090",
    "data-name": "Rectangle 4090",
    width: 19.174,
    height: 1.722,
    transform: "translate(15.26 1.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4091",
    "data-name": "Rectangle 4091",
    width: 19.174,
    height: 1.722,
    transform: "translate(15.26 6.887)",
    fill: "#b22234"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4092",
    "data-name": "Rectangle 4092",
    width: 19.174,
    height: 1.722,
    transform: "translate(15.26 5.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11580",
    "data-name": "Path 11580",
    d: "M1.056,10.975.707,10.69h.431l.055-.19.011-.04.038-.13.029-.1.029.1.04.13.011.04.053.19h.435l-.351.285.135.457-.351-.283-.349.283Zm2.542,0-.349-.285h.433l.055-.19.013-.04.038-.13.027-.1.029.1.038.13.011.04.055.19H4.38l-.349.285.135.457-.351-.283-.349.283Zm2.544,0-.349-.285h.433l.053-.19.013-.04.04-.13.027-.1.029.1.038.13.011.04.057.19h.431l-.349.285.135.457-.351-.283-.349.283Zm2.544,0-.349-.285h.431l.055-.19.013-.04.038-.13.027-.1.031.1.038.13.013.04.055.19h.431l-.349.285.133.457L8.9,11.15l-.347.283Zm2.544,0-.349-.285h.431l.055-.19.013-.04.038-.13.029-.1.027.1.04.13.013.04.053.19h.433l-.349.285.133.457-.349-.283-.351.283Zm2.544,0-.351-.285h.433l.057-.19.011-.04.038-.13.029-.1.027.1.038.13.013.04.055.19h.433l-.349.285.133.457-.349-.283-.351.283ZM2.336,9.773l-.349-.285h.431l.135-.457.133.457h.433l-.349.285.133.46-.349-.285-.351.285Zm2.544,0-.349-.285h.431L5.1,9.03l.133.457h.433l-.349.285.133.46L5.1,9.947l-.351.285Zm2.544,0-.351-.285h.435L7.64,9.03l.133.457H8.2l-.349.285.135.46L7.64,9.947l-.349.285Zm2.544,0-.349-.285h.431l.135-.457.133.457h.433l-.351.285.135.46-.349-.285-.349.285Zm2.544,0-.349-.285h.431l.133-.457.133.457h.435l-.351.285.135.46-.351-.285-.349.285ZM.988,8.8,1,8.761l.044-.155.011-.035L.707,8.285h.431l.133-.457.133.457h.435l-.351.285.011.035.044.155.013.04.066.23L1.341,8.8l-.053-.04-.018-.015-.018.015L1.2,8.8l-.281.23Zm2.544,0,.013-.04.044-.155L3.6,8.57l-.349-.285h.433l.133-.457.133.457H4.38l-.349.285.011.035.044.155L4.1,8.8l.069.23L3.885,8.8l-.053-.04-.018-.015L3.8,8.761l-.051.04-.281.23Zm2.544,0,.011-.04.046-.155.009-.035-.349-.285h.433l.133-.457.135.457h.431l-.349.285.011.035.044.155.011.04.069.23L6.427,8.8l-.051-.04-.018-.015-.018.015L6.29,8.8l-.281.23Zm2.544,0,.011-.04.044-.155.011-.035-.349-.285h.431L8.9,7.828l.137.457h.431l-.349.285.011.035.044.155.011.04.066.23L8.97,8.8l-.051-.04L8.9,8.745l-.015.015-.051.04-.281.23Zm2.544,0,.011-.04.044-.155.011-.035-.349-.285h.431l.135-.457.133.457h.433l-.349.285.009.035.046.155.011.04.066.23-.281-.23-.051-.04-.018-.015-.018.015-.051.04-.283.23Zm2.542,0,.011-.04.046-.155.011-.035-.351-.285h.433l.135-.457.133.457h.433l-.349.285.009.035.044.155.013.04.066.23-.283-.23-.049-.04-.018-.015-.018.015-.053.04-.281.23ZM2.336,7.37,2.009,7.1l-.022-.018h.431l.009-.024.049-.175.077-.261.075.261.051.175.007.024h.433L3.1,7.1l-.327.267.133.457-.349-.283L2.2,7.828Zm2.544,0L4.55,7.1l-.02-.018h.431l.007-.024.053-.175L5.1,6.626l.075.261.051.175.007.024h.433L5.64,7.1l-.327.267.133.457L5.1,7.545l-.351.283Zm2.544,0L7.094,7.1l-.022-.018h.435l0-.024.053-.175.075-.261.075.261.051.175.007.024H8.2l-.02.018-.329.267.135.457L7.64,7.545l-.349.283Zm2.544,0L9.638,7.1l-.02-.018h.431l.007-.024.051-.175.077-.261.075.261.051.175.007.024h.433l-.022.018L10.4,7.37l.135.457-.349-.283-.349.283Zm2.544,0L12.182,7.1l-.02-.018h.431l.009-.024.049-.175.075-.261.075.261.053.175,0,.024h.435l-.022.018-.329.267.135.457-.351-.283-.349.283ZM1.056,6.166.707,5.883h.431l.133-.46.133.46h.435l-.351.283.135.46-.351-.283-.349.283Zm2.542,0-.349-.283h.433l.133-.46.133.46H4.38l-.349.283.135.46-.351-.283-.349.283Zm2.544,0-.349-.283h.433l.133-.46.135.46h.431l-.349.283.135.46-.351-.283-.349.283Zm2.544,0-.349-.283h.431l.133-.46.137.46h.431l-.349.283.133.46L8.9,6.343l-.347.283Zm2.544,0-.349-.283h.431l.135-.46.133.46h.433l-.349.283.133.46-.349-.283-.351.283Zm2.544,0-.351-.283h.433l.135-.46.133.46h.433l-.349.283.133.46-.349-.283-.351.283ZM2.208,5.4l.013-.04.057-.2.057-.2-.349-.283h.431l.135-.457.133.457h.433l-.349.283.057.2.057.2L2.9,5.4l.007.022L2.875,5.4l-.049-.04-.245-.2-.029-.022-.031.022-.243.2-.051.04L2.2,5.423Zm2.544,0,.013-.04.057-.2.057-.2-.349-.283h.431L5.1,4.223l.133.457h.433l-.349.283.057.2.057.2.013.04,0,.022L5.419,5.4l-.051-.04-.243-.2L5.1,5.141l-.031.022-.243.2-.051.04-.027.022ZM7.3,5.4l.013-.04.057-.2.057-.2-.351-.283h.435l.133-.457.133.457H8.2l-.349.283.06.2.057.2.013.04,0,.022L7.965,5.4l-.053-.04-.243-.2L7.64,5.141l-.031.022-.243.2-.051.04-.024.022Zm2.544,0,.013-.04.057-.2.057-.2-.349-.283h.431l.135-.457.133.457h.433l-.351.283.057.2.057.2.013.04.007.022L10.509,5.4l-.053-.04-.243-.2-.029-.022-.031.022-.243.2-.051.04-.024.022Zm2.542,0,.013-.04.057-.2.06-.2-.349-.283h.431l.133-.457.133.457h.435l-.351.283.057.2.057.2.013.04.007.022L13.05,5.4,13,5.362l-.243-.2-.031-.022-.029.022-.243.2L12.4,5.4l-.024.022ZM1.056,3.764.983,3.7.93,3.662.707,3.479h.431l.009-.035.124-.424.124.424.009.035h.435l-.228.183L1.56,3.7l-.073.06.135.46-.351-.285-.349.285Zm2.542,0L3.527,3.7l-.053-.042-.225-.183h.433l.009-.035.124-.424.124.424.009.035H4.38l-.225.183L4.1,3.7l-.073.06.135.46-.351-.285-.349.285Zm2.544,0L6.069,3.7l-.051-.042-.225-.183h.433l.011-.035.122-.424.124.424.011.035h.431L6.7,3.662,6.648,3.7l-.073.06.135.46-.351-.285-.349.285Zm2.544,0L8.612,3.7l-.051-.042-.225-.183h.431l.013-.035L8.9,3.019l.124.424.013.035h.431l-.228.183L9.191,3.7l-.073.06.133.46L8.9,3.938l-.347.285Zm2.544,0-.073-.06-.051-.042-.225-.183h.431l.011-.035.124-.424.122.424.011.035h.433l-.225.183-.051.042-.073.06.133.46-.349-.285-.351.285Zm2.544,0L13.7,3.7l-.051-.042-.228-.183h.433l.011-.035.124-.424.122.424.011.035h.433l-.225.183-.053.042-.071.06.133.46-.349-.285-.351.285ZM2.336,2.559l-.349-.281h.431L2.5,2l.013-.042.042-.144.042.144L2.608,2l.077.274h.433l-.349.281.133.46-.349-.283L2.2,3.019Zm2.544,0-.349-.281h.431L5.041,2l.013-.042L5.1,1.819l.042.144L5.149,2l.08.274h.433l-.349.281.133.46L5.1,2.736l-.351.283Zm2.544,0-.351-.281h.435L7.585,2,7.6,1.962l.042-.144.042.144L7.693,2l.08.274H8.2l-.349.281.135.46L7.64,2.736l-.349.283Zm2.544,0-.349-.281h.431L10.129,2l.011-.042.044-.144.042.144L10.237,2l.08.274h.433l-.351.281.135.46-.349-.283-.349.283Zm2.544,0-.349-.281h.431L12.672,2l.011-.042.042-.144.042.144L12.781,2l.077.274h.435l-.351.281.135.46-.351-.283-.349.283ZM.95,1.722l.106-.362L.707,1.074h.431L1.271.617l.133.457h.435l-.351.285.106.362.029.1-.119-.1-.232-.188-.228.188-.122.1Zm2.542,0L3.6,1.359l-.349-.285h.433L3.814.617l.133.457H4.38l-.349.285.106.362.029.1-.119-.1-.232-.188-.23.188-.119.1Zm2.546,0,.1-.362-.349-.285h.433L6.358.617l.135.457h.431l-.349.285.1.362.031.1-.122-.1-.23-.188-.23.188-.119.1Zm2.544,0,.1-.362-.349-.285h.431L8.9.617l.137.457h.431l-.349.285.1.362.029.1-.119-.1L8.9,1.534l-.228.188-.119.1Zm2.544,0,.1-.362-.349-.285h.431l.135-.457.133.457h.433l-.349.285.1.362.029.1-.119-.1-.23-.188-.23.188-.122.1Zm2.542,0,.106-.362-.351-.285h.433l.135-.457.133.457h.433l-.349.285.1.362.029.1-.119-.1-.23-.188-.232.188-.119.1ZM0,0V12.051H15.26V0Z",
    transform: "translate(0)",
    fill: "#3c3b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11581",
    "data-name": "Path 11581",
    d: "M.857,4.727l-.038.13L.806,4.9.75,5.09H.319l.349.283L.534,5.83l.351-.281.349.281L1.1,5.373l.349-.283H1.018L.965,4.9l-.013-.04-.04-.13-.027-.1Z",
    transform: "translate(0.387 5.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11582",
    "data-name": "Path 11582",
    d: "M2.009,4.727l-.038.13L1.96,4.9,1.9,5.09H1.47l.351.283-.135.457.351-.281.349.281-.133-.457L2.6,5.09H2.17L2.115,4.9,2.1,4.858l-.038-.13-.027-.1Z",
    transform: "translate(1.778 5.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11583",
    "data-name": "Path 11583",
    d: "M3.16,4.727l-.04.13-.011.04-.055.192H2.621l.351.283-.135.457.351-.281.349.281L3.4,5.373l.349-.283H3.321L3.266,4.9l-.013-.04-.038-.13-.027-.1Z",
    transform: "translate(3.171 5.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11584",
    "data-name": "Path 11584",
    d: "M4.309,4.727l-.038.13L4.26,4.9,4.2,5.09H3.772l.349.283-.133.457.349-.281.349.281-.133-.457L4.9,5.09H4.472L4.417,4.9,4.4,4.858l-.038-.13-.029-.1Z",
    transform: "translate(4.564 5.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11585",
    "data-name": "Path 11585",
    d: "M5.46,4.727l-.038.13-.013.04-.055.192H4.923l.349.283-.135.457.351-.281.349.281-.133-.457.349-.283H5.621L5.568,4.9l-.013-.04-.04-.13-.027-.1Z",
    transform: "translate(5.957 5.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11586",
    "data-name": "Path 11586",
    d: "M6.612,4.727l-.038.13-.011.04-.057.192H6.073l.351.283L6.29,5.83l.351-.281.349.281-.133-.457.349-.283H6.774L6.718,4.9l-.013-.04-.038-.13-.027-.1Z",
    transform: "translate(7.349 5.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11587",
    "data-name": "Path 11587",
    d: "M.751,4H.32l.349.285-.011.035-.044.152L.6,4.515l-.066.23.283-.23.049-.042L.883,4.46.9,4.473l.053.042.281.23-.066-.23-.011-.042-.046-.152L1.1,4.285,1.451,4H1.018L.883,3.543Z",
    transform: "translate(0.387 4.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11588",
    "data-name": "Path 11588",
    d: "M1.9,4H1.47l.349.285-.009.035-.044.152-.013.042-.066.23.281-.23.051-.042.018-.013.018.013.053.042.281.23-.069-.23-.011-.042-.044-.152-.011-.035L2.6,4H2.17l-.135-.457Z",
    transform: "translate(1.779 4.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11589",
    "data-name": "Path 11589",
    d: "M3.054,4H2.621l.349.285-.009.035-.046.152L2.9,4.515l-.066.23.281-.23.051-.042.018-.013.018.013.051.042.283.23-.069-.23-.011-.042-.044-.152L3.4,4.285,3.753,4H3.322l-.135-.457Z",
    transform: "translate(3.172 4.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11590",
    "data-name": "Path 11590",
    d: "M4.2,4H3.772l.349.285-.011.035-.044.152-.011.042-.066.23.281-.23.051-.042.015-.013.018.013.053.042.281.23-.066-.23L4.61,4.473l-.044-.152-.013-.035L4.9,4H4.473l-.137-.457Z",
    transform: "translate(4.565 4.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11591",
    "data-name": "Path 11591",
    d: "M5.354,4H4.923l.347.285-.009.035-.044.152L5.2,4.515l-.066.23.283-.23.049-.042.018-.013.018.013.053.042.281.23-.066-.23-.011-.042-.046-.152L5.7,4.285,6.055,4H5.622l-.135-.457Z",
    transform: "translate(5.958 4.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11592",
    "data-name": "Path 11592",
    d: "M6.507,4H6.073l.349.285-.009.035-.046.152-.011.042-.066.23.281-.23.051-.042.018-.013.018.013.051.042.283.23-.069-.23-.011-.042-.044-.152-.011-.035L7.207,4H6.774l-.135-.457Z",
    transform: "translate(7.349 4.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11593",
    "data-name": "Path 11593",
    d: "M.751,2.914H.32L.669,3.2l-.135.46.349-.283.351.283L1.1,3.2l.351-.283H1.018l-.135-.46Z",
    transform: "translate(0.387 2.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11594",
    "data-name": "Path 11594",
    d: "M1.9,2.914H1.47l.349.283-.133.46.349-.283.351.283L2.252,3.2,2.6,2.914H2.17l-.135-.46Z",
    transform: "translate(1.779 2.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11595",
    "data-name": "Path 11595",
    d: "M3.054,2.914H2.621L2.97,3.2l-.133.46.349-.283.351.283L3.4,3.2l.349-.283H3.322l-.135-.46Z",
    transform: "translate(3.172 2.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11596",
    "data-name": "Path 11596",
    d: "M4.2,2.914H3.772l.349.283-.133.46.347-.283.351.283L4.552,3.2,4.9,2.914H4.473l-.137-.46Z",
    transform: "translate(4.565 2.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11597",
    "data-name": "Path 11597",
    d: "M5.354,2.914H4.923L5.27,3.2l-.133.46.349-.283.351.283L5.7,3.2l.351-.283H5.622l-.135-.46Z",
    transform: "translate(5.958 2.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11598",
    "data-name": "Path 11598",
    d: "M6.507,2.914H6.073l.349.283-.133.46.349-.283.351.283L6.856,3.2l.351-.283H6.774l-.135-.46Z",
    transform: "translate(7.349 2.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11599",
    "data-name": "Path 11599",
    d: "M.761,1.791.75,1.826H.319l.225.183L.6,2.051l.075.06-.137.46.351-.285.349.285L1.1,2.111l.073-.06.051-.042.225-.183H1.018l-.009-.035L.885,1.366Z",
    transform: "translate(0.387 1.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11600",
    "data-name": "Path 11600",
    d: "M1.914,1.791,1.9,1.826H1.469l.228.183.051.042.073.06-.135.46.351-.285.349.285-.133-.46.071-.06.053-.042L2.6,1.826H2.17l-.009-.035-.124-.424Z",
    transform: "translate(1.778 1.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11601",
    "data-name": "Path 11601",
    d: "M3.065,1.791l-.011.035H2.62l.228.183.049.042.075.06-.135.46.351-.285.349.285L3.4,2.111l.073-.06.053-.042.223-.183H3.321l-.009-.035-.124-.424Z",
    transform: "translate(3.171 1.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11602",
    "data-name": "Path 11602",
    d: "M4.216,1.791,4.2,1.826H3.772L4,2.009l.051.042.075.06-.135.46.349-.285.349.285-.133-.46.073-.06.051-.042L4.9,1.826H4.472l-.011-.035-.124-.424Z",
    transform: "translate(4.564 1.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11603",
    "data-name": "Path 11603",
    d: "M5.365,1.791l-.011.035H4.923l.225.183.051.042.073.06-.135.46.351-.285.349.285-.133-.46.073-.06.051-.042.225-.183H5.621l-.009-.035-.124-.424Z",
    transform: "translate(5.957 1.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11604",
    "data-name": "Path 11604",
    d: "M6.517,1.791l-.011.035H6.073l.228.183.051.042.073.06-.135.46.351-.285.349.285-.133-.46.071-.06.053-.042.225-.183H6.773l-.009-.035-.124-.424Z",
    transform: "translate(7.349 1.653)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11605",
    "data-name": "Path 11605",
    d: "M1.423.969l-.011.042-.08.272H.9l.351.283-.135.46.349-.285.349.285-.133-.46.349-.283H1.6L1.52,1.011,1.507.969,1.465.823Z",
    transform: "translate(1.088 0.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11606",
    "data-name": "Path 11606",
    d: "M2.574.969l-.011.042-.08.272H2.05l.349.283-.133.46.349-.285.349.285-.133-.46.349-.283H2.748l-.08-.272L2.658.969,2.616.823Z",
    transform: "translate(2.481 0.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11607",
    "data-name": "Path 11607",
    d: "M3.726.969l-.013.042-.077.272H3.2l.351.283-.133.46.349-.285.349.285-.135-.46.349-.283H3.9l-.08-.272L3.81.969,3.768.823Z",
    transform: "translate(3.872 0.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11608",
    "data-name": "Path 11608",
    d: "M4.875.969l-.011.042-.08.272H4.351l.351.283-.135.46.351-.285.347.285-.133-.46.349-.283H5.052l-.08-.272L4.961.969,4.919.823Z",
    transform: "translate(5.265 0.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11609",
    "data-name": "Path 11609",
    d: "M6.026.969l-.011.042-.08.272H5.5l.351.283-.135.46.349-.285.349.285-.133-.46.349-.283H6.2l-.077-.272L6.11.969,6.068.823Z",
    transform: "translate(6.658 0.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11610",
    "data-name": "Path 11610",
    d: "M1.33,2.369H.9l.349.285-.06.2-.055.2-.013.04-.007.022.027-.022.051-.04.243-.2.029-.024.031.024.243.2.051.04.027.022-.007-.022L1.8,3.051l-.06-.2-.057-.2.351-.285H1.6l-.135-.457Z",
    transform: "translate(1.089 2.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11611",
    "data-name": "Path 11611",
    d: "M2.481,2.369H2.05l.347.285-.057.2-.057.2-.011.04-.007.022.027-.022.051-.04.243-.2.029-.024.031.024.243.2.051.04.027.022-.007-.022-.011-.04-.06-.2-.057-.2.351-.285H2.749l-.135-.457Z",
    transform: "translate(2.481 2.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11612",
    "data-name": "Path 11612",
    d: "M3.634,2.369H3.2l.349.285-.057.2-.057.2-.011.04-.007.022.027-.022.049-.04.245-.2.029-.024.031.024.243.2.051.04.027.022-.007-.022L4.1,3.051l-.06-.2-.057-.2.349-.285H3.9l-.135-.457Z",
    transform: "translate(3.873 2.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11613",
    "data-name": "Path 11613",
    d: "M4.783,2.369H4.352l.349.285-.057.2-.057.2-.011.04-.007.022.027-.022.049-.04.245-.2.029-.024.029.024.243.2.053.04.024.022L5.26,3.091l-.011-.04-.06-.2-.057-.2.351-.285H5.052l-.135-.457Z",
    transform: "translate(5.266 2.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11614",
    "data-name": "Path 11614",
    d: "M5.934,2.369H5.5l.349.285-.06.2-.057.2-.011.04-.007.022.027-.022.051-.04.243-.2.029-.024.031.024.243.2.051.04.027.022-.007-.022L6.4,3.051l-.06-.2-.057-.2.351-.285H6.2l-.135-.457Z",
    transform: "translate(6.659 2.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11615",
    "data-name": "Path 11615",
    d: "M1.388,3.259l-.049.175-.009.024H.9l.02.018.329.267L1.114,4.2l.349-.283.351.283L1.68,3.743l.329-.267.022-.018H1.6l0-.024-.053-.175L1.463,3Z",
    transform: "translate(1.089 3.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11616",
    "data-name": "Path 11616",
    d: "M2.539,3.259l-.051.175-.007.024H2.051l.02.018.327.267L2.265,4.2l.349-.283.351.283-.135-.457.329-.267.022-.018H2.747l0-.024-.053-.175L2.614,3Z",
    transform: "translate(2.482 3.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11617",
    "data-name": "Path 11617",
    d: "M3.691,3.259l-.051.175-.007.024H3.2l.022.018.327.267L3.417,4.2l.349-.283.351.283-.137-.457.329-.267.022-.018H3.9l-.007-.024-.051-.175L3.766,3Z",
    transform: "translate(3.873 3.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11618",
    "data-name": "Path 11618",
    d: "M4.84,3.259l-.051.175-.007.024H4.352l.02.018.329.267L4.568,4.2l.349-.283.349.283-.135-.457.329-.267.022-.018H5.05l-.007-.024-.051-.175L4.918,3Z",
    transform: "translate(5.266 3.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11619",
    "data-name": "Path 11619",
    d: "M5.991,3.259l-.049.175-.009.024H5.5l.02.018.329.267L5.717,4.2l.349-.283.351.283-.135-.457.329-.267.022-.018H6.2l0-.024-.053-.175L6.067,3Z",
    transform: "translate(6.659 3.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11620",
    "data-name": "Path 11620",
    d: "M1.33,4.544H.9l.349.285-.135.46L1.463,5l.351.285-.135-.46.351-.285H1.6l-.135-.457Z",
    transform: "translate(1.089 4.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11621",
    "data-name": "Path 11621",
    d: "M2.481,4.544H2.05l.347.285-.133.46L2.614,5l.351.285-.135-.46.351-.285H2.749l-.135-.457Z",
    transform: "translate(2.481 4.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11622",
    "data-name": "Path 11622",
    d: "M3.634,4.544H3.2l.349.285-.133.46L3.766,5l.351.285-.135-.46.349-.285H3.9l-.135-.457Z",
    transform: "translate(3.873 4.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11623",
    "data-name": "Path 11623",
    d: "M4.783,4.544H4.352l.349.285-.133.46L4.918,5l.349.285-.135-.46.351-.285H5.052l-.135-.457Z",
    transform: "translate(5.266 4.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11624",
    "data-name": "Path 11624",
    d: "M5.934,4.544H5.5l.349.285-.135.46L6.066,5l.351.285-.135-.46.351-.285H6.2l-.135-.457Z",
    transform: "translate(6.659 4.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11625",
    "data-name": "Path 11625",
    d: "M.751.737H.32l.349.285-.106.36-.029.1.122-.1L.883,1.2l.232.186.119.1-.029-.1L1.1,1.022,1.451.737H1.018L.883.279Z",
    transform: "translate(0.387 0.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11626",
    "data-name": "Path 11626",
    d: "M1.9.737H1.47l.349.285-.1.36-.029.1.119-.1.23-.186.232.186.119.1-.029-.1-.106-.36L2.6.737H2.17L2.036.279Z",
    transform: "translate(1.779 0.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11627",
    "data-name": "Path 11627",
    d: "M3.054.737H2.621l.349.285-.1.36-.029.1.119-.1.23-.186.23.186.122.1-.031-.1-.1-.36L3.753.737H3.322L3.187.279Z",
    transform: "translate(3.172 0.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11628",
    "data-name": "Path 11628",
    d: "M4.2.737H3.772l.349.285-.106.36-.027.1.119-.1L4.336,1.2l.232.186.119.1-.029-.1-.106-.36L4.9.737H4.473L4.336.279Z",
    transform: "translate(4.565 0.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11629",
    "data-name": "Path 11629",
    d: "M5.354.737H4.923l.347.285-.1.36-.029.1.122-.1L5.487,1.2l.232.186.119.1-.029-.1L5.7,1.022,6.055.737H5.622L5.487.279Z",
    transform: "translate(5.958 0.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11630",
    "data-name": "Path 11630",
    d: "M6.507.737H6.073l.349.285-.1.36-.029.1.119-.1.23-.186.232.186.119.1-.029-.1-.106-.36L7.207.737H6.774L6.639.279Z",
    transform: "translate(7.349 0.338)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFLag);
export default __webpack_public_path__ + "static/media/US-FLag.659baabb2b4bc16adf445c12f4ab318b.svg";
export { ForwardRef as ReactComponent };